import { Routes } from '@angular/router';

export const AUTH_ROUTES: Routes = [
  {
    path: 'login',
    loadComponent: () => import('./login/login.component'),
  },
  {
    path: 'register',
    loadComponent: () => import('./register/register.component'),
  },
  {
    path: 'verify-email',
    loadComponent: () => import('./verify-email/verify-email.component'),
  },
  {
    path: 'forgot-password',
    loadComponent: () => import('./password-reset-request/password-reset-request.component'),
  },
  {
    path: 'reset-password',
    loadComponent: () => import('./password-reset-confirm/password-reset-confirm.component'),
  },
  {
    // The URL the team-invitation email links to: {Email:AppBaseUrl}/auth/accept-invite?token=...
    //
    // Deliberately unguarded. An invitee who has never used Privaci has no account to sign in
    // with, so authGuard would send them to a login form they cannot satisfy. The screen reads the
    // invitation anonymously and then asks for the one thing that is missing — a password for a
    // new person, a sign-in for someone who already has an account (carrying ?returnUrl so login
    // brings them back with the token intact).
    path: 'accept-invite',
    loadComponent: () => import('./accept-invite/accept-invite.component'),
  },
  { path: '', redirectTo: 'login', pathMatch: 'full' },
];
